export const openSidebar = () => ({
    type: "OPEN_SIDEBAR"
})
export const closeSidebar = () => ({
    type: "CLOSE_SIDEBAR"
})


// WEBPACK FOOTER //
// ./src/actions/appActions.js